module.exports = __webpack_public_path__ + "images/kaitori_bonus_lp/step-4-img-pc_66369056be6d8951df375ba7dcff830f.png";